<!-- eslint-disable vue/no-v-html -->
<template>
  <div @mousemove="mouseMove">
    <!-- <div v-if="loading" class="w-full">
      <FullScreeenLoader />
    </div> -->
    <div class="overflow-hidden">
      <div class="navbar-wrapper">
        <Navbar
          :is-dark="true"
          @mouseover="
            setCursor(null, null, {
              'font-size': '14px',
              cursor: 'unset',
              'z-index': '1',
              width: '25px',
              height: '25px',
              opacity: 0.7,
            })
          "
        />
      </div>

      <div class="lg:relative">
        <Bubbles
          v-if="width > 1024"
          :key="width"
          class="w-full !absolute top-0"
          :height="getHeight"
          :start-width="700"
          :set-cursor="setCursor"
          ref-prop="canvasabout"
        />
        <div class="w-full pt-28 lg:pt-32 pointer-events-none">
          <div class="flex justify-start lg:justify-center pointer-events-none">
            <div
              class="max-w-7xl relative overflow-hidden w-[1280px] pointer-events-none"
            >
              <div
                class="pb-12 lg:pb-24 px-0 sm:px-6 pointer-events-none"
              >
                <AnimateTitle :title="$t('about.title')" />
              </div>
              <div
                class="w-screen max-w-7xl flex justify-center relative pointer-events-auto"
              >
                <video
                  id="hero-video"
                  ref="aboutUsVideo"
                  autoplay
                  loop
                  muted
                  playsinline
                >
                  <source
                    src="https://be.opero.cz/wp-content/uploads/2024/03/Opero_byznys_hub_praha_clenstvi_coworking_titulky_cz.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
                <button
                  class="text-white absolute bottom-4 right-4 cursor-pointer z-50 w-11 h-11 rounded-[100%] bg-[#1a1a1a]"
                  @click="toggleMute"
                >
                  <Icon v-if="videoMuted" name="mdi:volume-off" size="24px" />
                  <Icon v-else name="mdi:volume" size="24px" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="lg:flex justify-center"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
          })
        "
      >
        <div class="max-w-7xl">
          <div
            class="flex flex-col md:flex-row gap-5 md:gap-28 p-6 py-12 md:px-6 lg:py-24"
          >
            <h2 class="h1 lg:whitespace-nowrap">
              <span class="whitespace-nowrap">{{
                $t("about.whyWeDo.title.part1")
              }}</span>
              <br class="block lg:hidden" />
              {{ $t("about.whyWeDo.title.part2") }}
            </h2>
            <div class="txt-l flex-2">
              {{ $t("about.whyWeDo.subtitle") }}
            </div>
          </div>
        </div>
      </div>

      <HowWeHelp2 :set-cursor="setCursor" />
      <div class="mt-12 flex justify-center">
        <button
          class="z-50 pointer-events-auto whitespace-nowrap bg-transparent border rounded-full border-black px-4 py-2 text-sm !font-normal"
          @click="
            navigateTo({
              path: localePath({ name: 'contact' }),
              query: { from: 'membership' },
            })
          "
        >
          {{ $t("events.becomeMember") }}
        </button>
      </div>

      <div
        class="lg:flex justify-center"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
          })
        "
      >
        <div class="max-w-7xl w-full">
          <div class="md:flex">
            <h2 class="h1 px-6 pt-20 pb-6 lg:pb-12">
              {{ $t("about.team.title.part1") }}<br class="hidden md:block" />
              {{ $t("about.team.title.part2") }}
            </h2>
          </div>
        </div>
      </div>

      <div
        @mouseenter="
          setCursor(null, scrollTo, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
          })
        "
      >
        <NewPeopleCarousel :set-cursor="setCursor" :width="width" />
      </div>

      <div
        class="our-story lg:flex justify-center"
        @mouseenter="
          setCursor(null, scrollTo, {
            'font-size': '14px',
            background: '#FFF',
            width: '25px',
            height: '25px',
            'z-index': '1',
            position: 'absolute',
          })
        "
      >
        <div class="max-w-7xl">
          <div
            class="flex flex-col md:flex-row gap-5 md:gap-28 p-6 py-12 md:px-6 lg:py-24"
          >
            <h2 class="h1 mt-8 mb-6 md:mt-0 md:mb-0 whitespace-nowrap">
              {{ $t("about.ourStory.title") }}
            </h2>
            <div class="flex-2">
              <p>{{ $t("about.ourStory.part1") }}</p>
              <p class="mt-4">{{ $t("about.ourStory.part2") }}</p>
              <p class="mt-4">{{ $t("about.ourStory.part3") }}</p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <img class="w-full" src="/img/imagehistory.png" />
      </div>

      <div
        class="lg:flex justify-center"
        @mouseenter="
          setCursor(null, scrollTo, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
            position: 'absolute',
          })
        "
      >
        <div class="max-w-7xl">
          <div
            class="flex flex-col md:flex-row gap-5 md:gap-28 p-6 py-12 md:px-6 lg:pt-24 lg:pb-20"
          >
            <h2
              class="h1 mt-8 mb-6 md:mt-0 md:mb-0"
              v-html="$t('about.history.title')"
            />
            <div class="flex-2">
              <p>{{ $t("about.history.part1") }}</p>
              <p class="mt-4">{{ $t("about.history.part2") }}</p>
              <!-- <p class="mt-4">{{ $t("about.history.part3") }}</p> -->
            </div>
          </div>
        </div>
      </div>

      <div>
        <div
          class="lg:flex justify-center"
          @mouseenter="
            setCursor(null, scrollTo, {
              'font-size': '14px',
              background: '#FFC800',
              width: '25px',
              height: '25px',
              'z-index': '-1',
              position: 'absolute',
            })
          "
        >
          <div class="w-full max-w-7xl px-6 pb-12 md:pb-24">
            <div class="md:grid grid-cols-2 gap-4">
              <div class=" ">
                <img
                  src="/img/history2.png"
                  class="w-full mb-4"
                  alt="Opero history"
                />
                <img
                  src="/img/history3.png"
                  class="w-full"
                  alt="Opero history"
                />
              </div>
              <div>
                <img
                  src="/img/history1.png"
                  class="h-full w-full md:w-auto"
                  alt="Opero history"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <PartnersWrapper :set-cursor="setCursor" />
      </div>

      <div>
        <div
          class="flex justify-center mt-20 mb-11"
          @mouseenter="
            setCursor(null, scrollTo, {
              'font-size': '14px',
              background: '#FFC800',
              width: '25px',
              height: '25px',
              'z-index': '-1',
              position: 'absolute',
            })
          "
        >
          <div class="max-w-7xl md:text-center w-full px-6">
            <h2 class="mb-4">{{ $t("about.said.title") }}</h2>
            <p class="mb-12">
              {{ $t("about.said.subtitle") }}<br class="hidden md:block" />
              {{ $t("about.said.subtitle.part2") }}
            </p>
            <button
              class="bg-white border rounded-full border-black px-4 py-2 text-sm"
              @click="navigateTo(localePath({ name: 'articles' }))"
            >
              {{ $t("about.said.button") }}
            </button>
          </div>
        </div>
      </div>
      <BecomeMember :set-cursor="setCursor" />
      <Footer :set-cursor="setCursor" />
      <div
        id="cursor"
        class="hidden cursor-auto lg:cursor-none lg:flex pointer-events-none"
        :style="cursorStyle"
        :class="{
          smallCursor: cursor === null,
        }"
        @click="cursorOnClick"
        v-html="cursor"
      ></div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
export default {
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    useHeadMeta({
      title: t("about.meta.title"),
      description: t("about.meta.description"),
      url: route.fullPath,
      csUrl: 'cs/o-nas',
      enUrl: 'en/about',
      image: "https://www.opero.cz/img/2_o_nas.jpg",
    });
  },
  data() {
    return {
      currentImage: 0,
      cursor: "",
      cursorStyle: {},
      width: 1365,
      xTo: null,
      yTo: null,
      data: null,
      loading: false,
      resizeKey: 0,
      localePath: useLocalePath(),
      videoMuted: true,
    };
  },
  computed: {
    getHeight() {
      return 1000;
    },
  },
  mounted() {
    const images = Array.from(document.querySelectorAll("img")); // Select all images
    const videos = Array.from(document.querySelectorAll("video")); // Select all videos
    const mediaElements = [...images, ...videos];

    const loadPromises = mediaElements.map(
      (element) =>
        new Promise((resolve) => {
          if (element.complete || element.readyState > 0) {
            resolve(null);
          } else {
            element.addEventListener("load", () => resolve(null), {
              once: true,
            });
          }
        })
    );
    this.resizeKey += 1;

    Promise.all(loadPromises).then(() => {
      this.loading = false;
      this.resizeKey += 1;

      setTimeout(() => {
        this.width =
          document?.body?.clientWidth ||
          window?.innerWidth ||
          document?.documentElement?.clientWidth;
        this.resizeKey += 1;
      }, "1500");
    });
    // TODO
    this.loading = false;

    this.width =
      document?.body?.clientWidth ||
      window?.innerWidth ||
      document?.documentElement?.clientWidth;
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("mousemove", this.mouseMove);

    if (this.width > 1024) {
      gsap.set("#cursor", { xPercent: -50, yPercent: -50 });

      this.xTo = gsap.quickTo("#cursor", "x", {
        duration: 0.1,
        ease: "power3",
      });
      this.yTo = gsap.quickTo("#cursor", "y", {
        duration: 0.1,
        ease: "power3",
      });
    }
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("mousemove", this.mouseMove);
    window.document.removeEventListener("click", this.cursorOnClick);
  },
  methods: {
    changeTestimonial(t) {
      this.currentImage = t;
    },
    changeTestimonial2(t) {
      this.currentImage2 = t;
    },
    setCursor(value, onClick, style) {
      this.cursor = value;
      if (this.cursorOnClick !== onClick) {
        window.document.removeEventListener("click", this.cursorOnClick);
        this.cursorOnClick = onClick;

        window.document.addEventListener("click", this.cursorOnClick);
      }
      if (this.cursorStyle !== style) {
        this.cursorStyle = style;
      }
      // console.log('setcur', this.cursorStyle, this.cursorOnClick)
    },
    cursorOnClick: () => {
      // console.log('sgsfd')
    },
    toggleMute() {
      this.videoMuted = !this.videoMuted;
      this.$refs.aboutUsVideo.muted = !this.$refs.aboutUsVideo.muted;
    },
    mouseMove(e) {
      if (this.width > 1024) {
        // this.xTo = e.pageX;
        // this.yTo = e.pageY;
        //
        if (this.xTo && this.yTo) {
          this.xTo(e.pageX);
          this.yTo(e.pageY);
        }
      }
    },
    handleResize() {
      this.resizeKey += 1;
      this.width =
        document?.body?.clientWidth ||
        window?.innerWidth ||
        document?.documentElement?.clientWidth;
      if (this.width > 1024) {
        gsap.set("#cursor", { xPercent: -50, yPercent: -50 });

        this.xTo = gsap.quickTo("#cursor", "x", {
          duration: 0.1,
          ease: "power3",
        });
        this.yTo = gsap.quickTo("#cursor", "y", {
          duration: 0.1,
          ease: "power3",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.our-story {
  background-color: $color-primary;
}
.helpinh-container {
  .txt-l {
    @media screen and (max-width: 1024px) {
      font-size: 28px !important;
    }
  }
}
.helpinh-img {
  width: 459px;
  height: 254px;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
    max-height: 200px;
  }
}

#cursor {
  position: absolute;
  top: 0;
  left: -10px;
  width: 25px;
  height: 25px;
  display: none;
  font-weight: 400;

  justify-content: center;
  align-items: center;
  background-color: $color-primary;
  border-radius: 50%;
  z-index: 1000;
  cursor: none;
  transition:
    width 0.3s,
    height 0.3s,
    background-color 0.3s;
  transform: translate(-50%, -50%) translate(-150px, -150px);
  //pointer-events: none;
  text-align: center;
  @media screen {
    @media (pointer: fine) {
      display: flex;
    }
  }
}

.smallCursor {
  width: 20px;
  height: 20px;
  background-color: $color-primary;
}

.h2-ngap {
  //background-color: #1A1A1A;
  margin-top: -10px;
  @media screen and (max-width: 1024px) {
    margin-top: -6px;
  }
}
</style>
